import { buildURI } from '@hn-front/utils';
import { COMMON_APP_ROUTES } from '../../Common/constants/routes';
export var getCustomizeTimeTargetLink = function (groupId) {
    return buildURI(COMMON_APP_ROUTES.controlWeeklyTargets, { pathParams: { groupId: groupId } });
};
